<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->
  $(function(){
    
    //SLICK CUSTOM RELATED PRODUCTS
    $('.related-product-list-js').slick({
      dots: false,
      infinite: true,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous" role="button"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="Next" role="button"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
    //END SLICK CUSTOM RELATED PRODUCTS

    //CUSTOM SWATCHES
    if($('.customSwatchContainer').length){
      const setSwatchTooltips = () => {
          $("[id^='js-teinte-swatch-']").each(function() {
              const id = $(this).attr('id');
              const index = id.split('-').pop();
              const optionText = $(`#js-teinte-option-${index}`).text().trim();
              $(this).prev().text(optionText);
          });
      };
  
      // setSwatchTooltips();
  
      function setCurrentSwatch(){
        const currentSwatch = $("[id^='js-teinte-option-']:selected").attr('id');
        const optionNum = currentSwatch.split('-').pop();
        // Parcours des éléments swatch
        $('[id^=js-teinte-swatch-]').each(function() {
            const swatchId = $(this).attr('id');
            const swatchNum = swatchId.split('-').pop();
    
            if (optionNum === swatchNum) {
                $(this).addClass('selected');
            }
        });
      }
      // setCurrentSwatch();
  
      $(document).on('click', '[id^=js-teinte-swatch-]', function() {
          $('.customSwatches-js.selected').removeClass('selected');
          $(this).addClass('selected');
          
          const id = $(this).attr('id'); // Obtient l'ID de l'élément cliqué
          const number = id.split('-').pop(); // Récupère le numéro {x}
          const optionId = '#js-teinte-option-' + number;
          const select = $(optionId).closest('select'); // Trouve le select contenant l'option correspondante
      
          // Change la valeur du select pour correspondre à l'option cliquée
          select.val($(optionId).val());
      
          // Simule un véritable événement de changement sur le select
          var event = new Event('change', {
              bubbles: true,
              cancelable: true
          });
          select[0].dispatchEvent(event);
      });
  
      if($('.swatchesContainer-js').length > 20){
        $('.customSwatchContainer').slick({
          // arrows: false,
          infinite: false,
          slidesToShow: 9,
          slidesToScroll: 9,
          prevArrow: '<button type="button" class="slick-prev" aria-label="Previous" role="button"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
          nextArrow: '<button type="button" class="slick-next" aria-label="Next" role="button"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
          responsive: [
            {
              breakpoint: 1440,
              settings: {
                slidesToShow: 7,
                slidesToScroll: 7,
              }
            },
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 8,
                slidesToScroll: 8,
              }
            },
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 7,
                slidesToScroll: 7,
              }
            },
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 6,
                slidesToScroll: 6,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 10,
                slidesToScroll: 10,
              }
            },
            {
              breakpoint: 690,
              settings: {
                slidesToShow: 9,
                slidesToScroll: 9,
              }
            },
            {
              breakpoint: 570,
              settings: {
                slidesToShow: 8,
                slidesToScroll: 8,
              }
            },
            {
              breakpoint: 520,
              settings: {
                slidesToShow: 7,
                slidesToScroll: 7,
              }
            },
            {
              breakpoint: 460,
              settings: {
                slidesToShow: 6,
                slidesToScroll: 6,
              }
            },
            {
              breakpoint: 375,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
              }
            },
          ]
        });
      }
    }
    //END CUSTOM SWATCHES


    //CUSTOM REASSURANCES
    $('.reassurancesList-js').slick({
      slidesToShow: 4, 
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous" role="button"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="Next" role="button"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
      responsive: [
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              }
            },
          ]
    });
    //END CUSTOM REASSURANCES

    //FAQ CATEGORIES
    $(document).on('click', '.accordion-header', function() {
        const accordionItem = $(this).parent('.accordion-item');
        const accordionContent = accordionItem.find('.accordion-content');
        const openIcon = accordionItem.find('.open-icon');
        const closeIcon = accordionItem.find('.close-icon');
        if (accordionContent.is(':visible')) {
            accordionContent.slideUp();
            openIcon.show();
            closeIcon.hide();
        } else {
            accordionContent.slideDown();
            openIcon.hide();
            closeIcon.show();
        }
    });
    //END FAQ CATEGORIES


    //SLICK BEST SELLERS HOME
    setTimeout(() => {
      $('.product-tab-block .product-tabs-content .products-grid').slick({
        slidesToShow: 4, 
        infinite: false,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Previous" role="button"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Next" role="button"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
        responsive: [
              {
                breakpoint: 1280,
                settings: {
                  slidesToShow: 3,
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                }
              },
            ]
      });
    }, "500");
    //END SLICK BEST SELLERS HOME



    //DROPDOWN TXT SEO
    $(document).on('click', '.viewMoreBtn-js', function(){
    	$(this).closest('.blocTxt-js').toggleClass('expand');
    	$(this).toggleClass('expand');
    });
    
    
    function appendViewMoreBtn(txtElement, txtElementInner, nbLines){
    	if (!txtElementInner.length) {
    		console.log("txtElementInner non trouvé.");
    		return;
    	}
    
    	const lineCount = countLines(txtElementInner);
    	console.log(lineCount); //DEBUG
    	if(lineCount > nbLines){
    		txtElementInner.css('-webkit-line-clamp', nbLines.toString());
    		txtElement.append(`
    			<span class="viewMoreBtn viewMoreBtn-js">
    				<span class="viewMore">Voir plus</span>
    				<span class="viewLess">Voir moins</span>
    			</span>
    		`);
    
    	}
    }
    
    function countLines(element) {
    	let divHeight = element.height();
    	let lineHeight = parseFloat(element.css('line-height'));
    
    	if (isNaN(lineHeight)) {
    		lineHeight = 1.2 * parseFloat(element.css('font-size'));
    	}
    
    	let lines = Math.round(divHeight / lineHeight);
    	return lines;
    }
    
    let txtElement = $('.blocTxt-js');
    let txtElementInner = $('.blocTxt-js .contentTxt');
    let nbLines = 10;
    appendViewMoreBtn(txtElement, txtElementInner, nbLines)
    //END DROPDOWN TXT SEO


    //SLIDER VIDEOS PRODUCT
    $('.sliderVideo-js').slick({
      slidesToShow: 3,
      prevArrow: '<button type="button" class="slick-prev" aria-label="Previous" role="button"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
      nextArrow: '<button type="button" class="slick-next" aria-label="Next" role="button"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
      responsive: [
            {
              breakpoint: 1280,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              }
            },
        ]
    });
    //END SLIDER VIDEOS PRODUCT

    $('.jdgm-rev-widg__reviews').slick({
          centerMode: true,
          centerPadding: '100px',
          slidesToShow: 3,
          dots: true,
          infinite: true,
          prevArrow: '<button type="button" class="slick-prev" aria-label="Previous" role="button"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
          nextArrow: '<button type="button" class="slick-next" aria-label="Next" role="button"><svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M 7.75 1.34375 L 6.25 2.65625 L 14.65625 12 L 6.25 21.34375 L 7.75 22.65625 L 16.75 12.65625 L 17.34375 12 L 16.75 11.34375 Z"></path></svg></button>',
          responsive: [
            {
              breakpoint: 768,
              settings: {
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                centerMode: true,
                centerPadding: '40px',
                slidesToShow: 1
              }
            }
          ]
      });


    //VIDEO SPEED x2 PRODUCT ID 14672259940727
    const video = $('#shopify-section-template--23751028638071__video_block_rrFJhn .js-video')[0]; // Accéder à l'élément DOM natif
    if (video) {
        video.addEventListener('loadeddata', function() {
            video.playbackRate = 2.0; // Définir la vitesse à 2x
        });
    }
    //VIDEO SPEED x2 PRODUCT ID 14672259940727
});
    
<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
